import { jsonb, pgTable, primaryKey, text, uuid } from "drizzle-orm/pg-core";
import { temporalTimestamps } from "../../utils/sql";
import { user } from "../../auth/core/user.sql";

export const draft = pgTable(
  "draft",
  {
    ...temporalTimestamps,
    userId: uuid("user_id")
      .references(() => user.id)
      .notNull(),
    type: text("type").notNull(),
    data: jsonb("data").notNull(),
  },
  (t) => [primaryKey({ name: "draft_pk", columns: [t.userId, t.type] })],
);
